export default [
  // 发布话题 -- 不用
  // {
  //   path: '/addActivity/comment',
  //   name: '发布话题',
  //   component: () => import(/* webpackChunkName: "addActivity" */ '../views/AddActivity/Comment/Comment.vue')
  // },
  // 发布作业 -- 不同
  {
    path: '/addActivity/task',
    name: '发布作业',
    component: () => import(/* webpackChunkName: "addActivity" */ '../views/AddActivity/Task/Task.vue'),
    meta: {
      keepAlive: false
    }
  },
  // 发布话题
  {
    path: '/addActivity/topic',
    name: '话题',
    component: () => import(/* webpackChunkName: "addActivity" */ '@/views/AddActivity/Topic/Topic.vue'),
    meta: {
      keepAlive: false
    }
  },
  // 发布公告
  {
    path: '/addActivity/notice',
    name: '发布公告',
    component: () => import(/* webpackChunkName: "addActivity" */ '@/views/AddActivity/Notice/Notice.vue'),
    meta: {
      keepAlive: false
    }
  },
  // 发布资料
  {
    path: '/addActivity/data',
    name: '发布资料',
    component: () => import(/* webpackChunkName: "addActivity" */ '@/views/AddActivity/Data/Data.vue'),
    meta: {
      keepAlive: false
    }
  },
  // 发布互动课件
  {
    path: '/addActivity/courseware',
    name: '发布课件',
    component: () => import(/* webpackChunkName: "addActivity" */ '@/views/AddActivity/Courseware/Courseware.vue'),
    meta: {
      keepAlive: false
    }
  },
  // 发布互动答题
  {
    path: '/addActivity/interactiveAnswers',
    name: '互动答题',
    component: () => import(/* webpackChunkName: "addActivity" */ '@/views/AddActivity/InteractiveAnswers/InteractiveAnswers.vue'),
    meta: {
      keepAlive: false
    }
  },
  // 总分
  {
    path: '/addActivity/score',
    name: 'fullScore',
    component: () => import(/* webpackChunkName: "addActivity" */ '@/views/AddActivity/Common/Score/Score.vue')
  },
  // 截至时间
  {
    path: '/addActivity/endTime',
    name: '截至时间',
    component: () => import(/* webpackChunkName: "addActivity" */ '@/views/AddActivity/Common/EndTime/EndTime.vue')
  },
  // 所属目录
  {
    path: '/addActivity/directory',
    name: 'directory',
    component: () => import(/* webpackChunkName: "addActivity" */ '@/views/AddActivity/Common/Directory/Directory.vue')
  },
  // 选择导入类型
  {
    path: '/addActivity/importType',
    name: '选择导入类型',
    component: () => import(/* webpackChunkName: "addActivity" */ '@/views/AddActivity/ImportType/ImportType.vue')
  },
  // 话题详情
  {
    path: '/topicDetail',
    name: 'TopicDetail',
    component: () => import(/* webpackChunkName: "activity" */ '@/views/AddActivity/Topic/Detail.vue')
  },
  // 公告详情
  {
    path: '/noticeDetail',
    name: 'NoticeDetail',
    component: () => import(/* webpackChunkName: "activity" */ '@/views/AddActivity/Notice/Detail.vue')
  },
  // 腾讯会议
  {
    path: '/addActivity/conference',
    name: '腾讯会议',
    component: () => import(/* webpackChunkName: "addActivity" */ '../views/AddActivity/Conference/Conference.vue'),
    meta: {
      keepAlive: true
    }
  },
];
